<template>
    <div class="RecommendedProject main margin-Top38">
        <DockingSystemTitle :title="'HICOOL推荐项目对接'" :moreType="true" :underlineType="false" :titleCenter="false" />
        <!-- nav -->


        <div class="RecommendedProjectNav">

            <div class="NavDiv" :class="[fieldSelect.id == item.id ? 'NavDiv_Active' :'']"
                v-for="(item,index) in fieldList" :key="index" @click="selectChange('fieldSelect',item)">
                {{item.title}}
            </div>
        </div>


        <!-- 活动内容 -->

        <el-row class="ProjectContent">

            <RecommendedProjectFrame :list="list" />


        </el-row>

    </div>
</template>

<script>


    import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue";//活动框title
    import RecommendedProjectFrame from "@/components/DockingSystem/ActivityFrame/RecommendedProjectFrame.vue";//推荐项目单个内容
    import axios from "axios"
    export default {
        props: {
            NavType: Boolean,//决定是否显示分类按钮
            list: Array,//项目显示数量
        },
        components: {
            DockingSystemTitle, RecommendedProjectFrame
        },
        data() {
            return {
                fieldList: [{ id: "0", title: "全部" }],//领域数据存储
                fieldSelect: { id: "0", title: "全部" },//领域选中,默认选中全部
            }
        },
        created: function () {
            let self = this;
            //获取领域
            axios.get('/api/jointterritorytype', {
                params: {
                }
            })
                .then(function (response) {
                    if (response.data.code == 0) {
                        for (let i in response.data.data) {
                            self.fieldList.push(response.data.data[i]);
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        methods: {
            selectChange(select, item) {
                //用户切换选择按钮，给背景颜色
                this[select] = item;
                //同时触发上层
                this.$emit('selectChange',
                    {
                        "select": select,
                        "item": item
                    }
                );

            }
        },

    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .RecommendedProject .ProjectContent {
            margin-left: 15px;
            margin-right: 1px;
            margin-top: 19px;
            padding-bottom: 23px;
        }
    }

    .margin-Top38 {
        margin-top: 38px;
    }

    .RecommendedProject {
        background-color: #06013d;
        border-radius: 25px;

    }

    .ProjectContent {
        /* display: flex; */
        /* justify-content: space-between; */
        /* flex-wrap: wrap; */
        margin-top: 39px;
        margin-left: 33px;
        margin-right: 17px;
        padding-bottom: 46px;
    }
</style>

<style scoped>
    @media (max-width: 768px) {
        .RecommendedProjectNav .NavDiv {
            margin-top: 19px;
            margin-right: 5px;
        }

        .RecommendedProjectNav {
            margin-left: 5px !important;
        }
    }

    .RecommendedProjectNav {
        margin-left: 33px;
        display: flex;
        justify-content: left;
        flex-wrap: wrap;

    }

    .NavDiv {

        padding: 7px 24px;
        border-radius: 21px;
        border: solid 1px #ffffff;
        margin-right: 31px;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        opacity: 0.85;
        margin-top: 41px;
        cursor: pointer;
    }

    .NavDiv_Active {
        border: solid 1px #ff00ff;
        background-color: #ff00ff;
    }
</style>